import { SEARCH_PREFIXES } from "../../utils/search-prefixes"

interface Props {
  onPick: (prefix: string) => void
}

// Human labels for the prefix registry. Anything without a label falls back
// to the raw prefix so a newly registered prefix still shows up.
const PREFIX_LABELS: Record<string, string> = {
  loid: "Loan officer ID",
  brand_id: "Brand ID",
  nmls: "NMLS",
  app_key: "App key"
}

export const getPrefixLabel = (prefix: string) =>
  PREFIX_LABELS[prefix] ?? prefix

// Tappable shortcuts for the `prefix:` searches. Typing a colon prefix on a
// phone keyboard is slow, so these drop it into the input for you.
const PrefixChips = ({ onPick }: Props) => {
  if (!SEARCH_PREFIXES.length) return null

  return (
    <div className="px-4 pt-3 pb-1">
      <div className="text-[11px] font-semibold uppercase tracking-wide text-neutral-400">
        Look up by ID
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        {SEARCH_PREFIXES.map(prefix => (
          <button
            key={prefix}
            type="button"
            onClick={() => onPick(prefix)}
            className="rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-xs font-medium text-neutral-700 transition-colors active:bg-primary-50 active:border-primary-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400/40"
          >
            {getPrefixLabel(prefix)}
          </button>
        ))}
      </div>
    </div>
  )
}

export default PrefixChips
